import { JSXElementConstructor, ReactElement } from "react";

export interface IFieldProps {
  label?: string | ReactElement<any, string | JSXElementConstructor<any>>;
  record?: { [key: string]: any } & object;
  source?: string;
  resource?: string;
  basePath?: string;
  hasShow?: boolean;
}

export class FieldProps implements IFieldProps {
  label: string = "";
  record: { [key: string]: any } & object = {};
  source: string = "";
  resource: string = "";
  basePath: string = "";
  hasShow: boolean = false;
}
